module.exports = __webpack_public_path__ + "img/livepen-tilt-ransparent.2df40ae2.png";